import { _ as _defineProperty } from '../../defineProperty-18999f8e.js';
import { a4 as cloneNode, a5 as hasLayerChildren, z as findNodeFirstIdentifier, a0 as destroyNode, s as setNodeAttrs, a6 as addNodeIntoLayer, a7 as toCanvas, a8 as destroyLayerChildren, a9 as toImage, p as getNodeAttrs, aa as toDataURL, l as createStage, m as createLayer, ab as addLayerToStage } from '../../selectors-f64b5778.js';
import '../../typeof-92b42de1.js';
import '../../slicedToArray-26803f33.js';
import '../../unsupportedIterableToArray-577176bf.js';
import '../../toConsumableArray-2a2700d9.js';
import '../../configs/index.js';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var getTmpCanvasEnvs = function () {
  var tmpStage = null;
  var tmpLayer = null;
  return function () {
    if (tmpStage && tmpLayer) {
      return {
        tmpStage: tmpStage,
        tmpLayer: tmpLayer
      };
    }

    tmpStage = createStage({
      container: document.createElement('div')
    });
    tmpLayer = createLayer();
    addLayerToStage(tmpStage, tmpLayer);
    return {
      tmpStage: tmpStage,
      tmpLayer: tmpLayer
    };
  };
}();

var getCloneOfRegistryLayer = function getCloneOfRegistryLayer(layerProvider, id, config) {
  var layer = layerProvider.layerRegistry[id].layer;
  return cloneNode(layer.renderable, _objectSpread({
    scale: {
      x: 1,
      y: 1
    }
  }, config));
};

var layerToCanvas = function layerToCanvas(layerProvider, id, config, cloneConfig) {
  var excludeIds = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
  var cloneLayer = getCloneOfRegistryLayer(layerProvider, id, cloneConfig);

  if (hasLayerChildren(cloneLayer)) {
    excludeIds.forEach(function (excludeId) {
      var excludeLayer = findNodeFirstIdentifier(cloneLayer, "#".concat(excludeId));
      excludeLayer && destroyNode(excludeLayer);
    });
  }

  var _cloneLayer$getClient = cloneLayer.getClientRect(),
      width = _cloneLayer$getClient.width,
      height = _cloneLayer$getClient.height;

  var _getTmpCanvasEnvs = getTmpCanvasEnvs(),
      tmpStage = _getTmpCanvasEnvs.tmpStage,
      tmpLayer = _getTmpCanvasEnvs.tmpLayer;

  var tmpStageWidth = config !== null && config !== void 0 && config.x ? width + config.x : width;
  var tmpStageHeight = config !== null && config !== void 0 && config.y ? height + config.y : height;
  setNodeAttrs(tmpStage, {
    width: tmpStageWidth,
    height: tmpStageHeight
  });
  addNodeIntoLayer(tmpLayer, cloneLayer);
  var canvas = toCanvas(cloneLayer, config);
  destroyLayerChildren(tmpLayer);
  return canvas;
};

var layerToImage = function layerToImage(layerProvider, id, config) {
  var excludeIds = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
  var baseGroupLayer = getCloneOfRegistryLayer(layerProvider, id, config);
  excludeIds.forEach(function (excludeId) {
    var excludeLayer = findNodeFirstIdentifier(baseGroupLayer, "#".concat(excludeId));
    excludeLayer && destroyNode(excludeLayer);
  });
  return toImage(baseGroupLayer, config);
};

var layerToDataUrl = function layerToDataUrl(layerProvider, _ref) {
  var id = _ref.id,
      config = _ref.config,
      cloneConfig = _ref.cloneConfig,
      _ref$excludeIds = _ref.excludeIds,
      excludeIds = _ref$excludeIds === void 0 ? [] : _ref$excludeIds;
  var cloneLayer = getCloneOfRegistryLayer(layerProvider, id, cloneConfig);

  var _getTmpCanvasEnvs2 = getTmpCanvasEnvs(),
      tmpStage = _getTmpCanvasEnvs2.tmpStage,
      tmpLayer = _getTmpCanvasEnvs2.tmpLayer;

  excludeIds.forEach(function (excludeId) {
    var excludeLayer = findNodeFirstIdentifier(cloneLayer, "#".concat(excludeId));
    excludeLayer && destroyNode(excludeLayer);
  });

  var _cloneLayer$getClient2 = cloneLayer.getClientRect(),
      width = _cloneLayer$getClient2.width,
      height = _cloneLayer$getClient2.height;

  var _getNodeAttrs = getNodeAttrs(cloneLayer),
      x = _getNodeAttrs.x,
      y = _getNodeAttrs.y;

  setNodeAttrs(tmpStage, {
    width: width + x,
    height: height + y
  });
  addNodeIntoLayer(tmpLayer, cloneLayer);
  var dataUrl = toDataURL(cloneLayer, config);
  destroyLayerChildren(tmpLayer);
  return dataUrl;
};

export { layerToCanvas, layerToDataUrl, layerToImage };
